import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { getInsightById } from "../services/insightsService";
import { useSelector } from "react-redux";
import { selectUserId } from "../store/slices/authUserSlice";

interface Insight {
  id: string;
  user_id: string;
  conversation_id: string;
  title: string;
  summary: string;
  quotes: string[];
  created_at: string;
}

const Insight: React.FC = () => {
  const { insightId } = useParams<{ insightId: string }>();
  const [insight, setInsight] = useState<Insight | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const userId = useSelector(selectUserId);

  useEffect(() => {
    if (!userId || !insightId) return;

    setIsLoading(true);
    getInsightById(insightId)
      .then((data) => {
        setInsight(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching insight:", error);
        setIsLoading(false);
      });
  }, [insightId, userId]);

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="typing-indicator">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }

  if (!insight) {
    return (
      <div className="empty-state-container">
        <h3>Insight not found</h3>
        <p>The insight you're looking for doesn't exist or has been removed.</p>
        <Link to="/insights" className="primary-button">
          Back to Insights
        </Link>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px" }}>
        <Link to="/insights" className="back-link">
          ← Back to insights
        </Link>
        <span style={{ color: "#666", fontSize: "14px" }}>
          {formatDate(insight.created_at)}
        </span>
      </div>

      <div style={{ marginBottom: "24px" }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "16px"
        }}>
          <h1 style={{ marginBottom: "8px" }}>{insight.title}</h1>
        </div>
        <div style={{ marginBottom: "32px" }}>
          {insight.summary.split('\n\n').map((paragraph, index) => (
            <p key={index} style={{ marginBottom: "16px", lineHeight: "1.6" }}>
              {paragraph}
            </p>
          ))}
        </div>

        <div>
          <h2 style={{
            fontSize: "20px",
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <span style={{
              color: "#666",
              fontSize: "24px",
              marginRight: "4px"
            }}>❝</span>
            Key Quotes
          </h2>

          <div style={{ marginBottom: "32px" }}>
            {insight.quotes.map((quote, index) => (
              <div
                key={index}
                style={{
                  padding: "16px",
                  marginBottom: "16px",
                  borderLeft: "3px solid #3182ce",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px"
                }}
              >
                <blockquote style={{ fontStyle: "italic" }}>
                  "{quote}"
                </blockquote>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "32px",
        borderTop: "1px solid #e2e8f0",
        paddingTop: "24px",
        marginBottom: "30px"
      }}>
        <div style={{

        }}>
          <button
            className="primary-button"
            onClick={() => {
              alert("Generate Posts - This feature will be available soon!");
            }}
          >
            Generate Posts
          </button>
        </div>
      </div>
    </div>
  );
};

export default Insight;
